import { useContext } from "react";
import { StoreContext } from "../context/StoreContext";

export default function useStore() {
  return useContext(StoreContext);
}
